

let mm = gsap.matchMedia(), breakPointHandy = 768, breakPointIpad = 1024; 

mm.add({
        // set up any number of arbitrarily-named conditions. The function below will be called when ANY of them match.
        isDesktop: `(min-width: ${breakPointIpad}px)`,
        isIpad: `(max-width: ${breakPointIpad - 1}px)`,
        isMobile: `(max-width: ${breakPointHandy - 1}px)`,
        reduceMotion: "(prefers-reduced-motion: reduce)",
    },
    (context) => {
        // context.conditions has a boolean property for each condition defined above indicating if it's matched or not.
        let { isDesktop, isIpad, isMobile, reduceMotion } = context.conditions;

    }
);

let isTouch = isTouchDevice();
let isDektop = mm.contexts[0].conditions.isDesktop;
let isIpad = mm.contexts[0].conditions.isIpad;
let isMobile = mm.contexts[0].conditions.isMobile; 




function scrollSmoother(){


    if (history.scrollRestoration) {
        history.scrollRestoration = 'manual';
    } else {
        window.onbeforeunload = function () {
            window.scrollTo(0, 0);
        }
    }

    gsap.registerPlugin(ScrollSmoother, ScrollTrigger);

    let smoother; 

    function smootherSetup() {

        smoother = ScrollSmoother.create({
            speed: 1,
            smooth: 2,               // how long (in seconds) it takes to "catch up" to the native scroll position
            effects: false,           // looks for data-speed and data-lag attributes on elements
            smoothTouch: 0.2, 
            preventDefault: true,
            normalizeScroll: true,
            //normalizeScroll: isTouch ? false : true,
            //ignoreMobileResize:  true
            
        });
    }

    function killSmoother() {
        if (!isMobile) {
            smoother.kill();
        }
    }

    function pauseSmoother() {
        if (!isMobile) {
            smoother.paused(true);
        }
    }

    function unpauseSmoother() {
        if (!isMobile) {
            smoother.paused(false);
        }
    }

    function scrollTo(y) {
        smoother.scrollTo(y);
    }
    return {
        kill    : killSmoother,
        init    : smootherSetup,
        pause   : pauseSmoother,
        unpause : unpauseSmoother,
        scrollTo : scrollTo,
    }
} 

// init ScrollSmoother
const _scrollSmoother = new scrollSmoother(); 
if (!isMobile) {
    _scrollSmoother.init();
}

